import Header from "./Header.js";
import Footer from "./Footer.js";
import { classUnion } from "../../util.js";

export function Page({children, className}) {
  return <div className={classUnion("h-full flex flex-col", className)}>
    <Header />
    <div className="grow">
      {children}
    </div>
    <Footer/>
  </div>
}
